// extracted by mini-css-extract-plugin
export default {"swStatusIndicator":"mfr-iTbpUBbL"};